import Ably from 'ably-hubspot-js';
import { AblyRealtimeWrapper } from 'ably-hubspot-js/ably/api-wrappers/AblyRealtimeWrapper';
import { AggregateDataReporter } from 'ably-hubspot-js/metrics/AggregateDataReporter';
import http from 'conversations-http/clients/http';
import Raven from 'raven-js';
import { safelyParseJson } from './utils';
const NO_INBOX_ID = 'usePubSub.NO_INBOX_ID';
const ABLY_WRAPPER_TRACKER = new Map();
const getTrackerId = inboxId => inboxId !== null && inboxId !== void 0 ? inboxId : NO_INBOX_ID;
const publishVerifier = (publishingMessageId, realtimeMessage) => {
  const topLevelIdsMatch = !!publishingMessageId && publishingMessageId === realtimeMessage.id;
  const realtimeMessageDataObject = safelyParseJson(realtimeMessage.data);
  const dataIdMatch = !!publishingMessageId && publishingMessageId === realtimeMessageDataObject.id;
  return topLevelIdsMatch || dataIdMatch;
};
const setupConnection = async inboxId => {
  const realtime = new Ably.Realtime({
    authCallback: (_tokenParams, callback) => {
      http.get('messages/v2/pubsub/token/agent', {
        query: {
          inboxId: inboxId !== null && inboxId !== void 0 ? inboxId : null,
          noCache: Math.random()
        }
      }).then(tokenResponse => callback('', tokenResponse)).catch(err => {
        callback(err, '');
        setTimeout(() => {
          throw err;
        });
      });
    }
  });
  const wrapper = new AblyRealtimeWrapper(realtime, new AggregateDataReporter(), publishVerifier);
  await wrapper.connect();
  return wrapper;
};
const getRealtime = inboxId => {
  var _ABLY_WRAPPER_TRACKER;
  return (_ABLY_WRAPPER_TRACKER = ABLY_WRAPPER_TRACKER.get(getTrackerId(inboxId))) === null || _ABLY_WRAPPER_TRACKER === void 0 ? void 0 : _ABLY_WRAPPER_TRACKER.wrapper;
};
const connect = async inboxId => {
  try {
    const trackerId = getTrackerId(inboxId);
    let tracker = ABLY_WRAPPER_TRACKER.get(trackerId);
    if (!tracker) {
      tracker = {
        subscribers: 0,
        wrapper: await setupConnection(inboxId)
      };
    }
    tracker.subscribers += 1;
    ABLY_WRAPPER_TRACKER.set(trackerId, tracker);
    return tracker.wrapper;
  } catch (error) {
    Raven.captureException(error);
  }
};
const removeListener = inboxId => {
  const trackerId = getTrackerId(inboxId);
  const tracker = ABLY_WRAPPER_TRACKER.get(trackerId);
  if (!tracker) {
    return;
  }
  tracker.subscribers -= 1;

  // There are no subscribers to this connection, so
  // we shouldn't leave it open
  if (tracker.subscribers < 1) {
    tracker.wrapper.close();
    ABLY_WRAPPER_TRACKER.delete(trackerId);
  } else {
    ABLY_WRAPPER_TRACKER.set(trackerId, tracker);
  }
};

/**
 * @description Manages connections to Ably, maintaining a single connection for an optional inbox ID. If a connection has no more listeners, it is closed and removed
 */
export const AblyConnections = {
  /**
   * @description Sets up a new tracker for Ably connection wrappers and sets up the Ably connection. If a wrapper already exists
   * for the inbox, it will be used
   */
  connect,
  /**
   * @description Gets the Ably.Realtime wrapper for an Ablye connection if one exists for the optional inbox ID
   */
  getRealtime,
  /**
   * @description Reduces the number of subscribers to an Ably connection by 1
   */
  removeListener
};